import { gql } from "@apollo/client";

export const CREATE_CHAT = gql`
    mutation CreateChat($name: String!, $isPrivate: Boolean) {
        createChat(name: $name, isPrivate: $isPrivate) {
            id
            createdAt
            updatedAt
            creatorId
            isPrivate
            name
            generatedSummary
            sizeInTokens
            sizeInPages
            totalTokensSpent
            totalPagesSpent
            settings
        }
    }
`;